// extracted by mini-css-extract-plugin
export default {"overlay":"vp_CYHTQ"};